import React from 'react';

const NutritionService = () => {
  return <div className="min-h-screen pt-24 container-custom"><h1 className="text-2xl">Nutrition Coaching</h1><p>Coming soon</p></div>;
};

export default NutritionService;